<template>
    <div>
        <app-header></app-header>
        <div class="grid-container pad-top--xl pad-bottom--xl">
            <div class="grid-x grid-margin-x">
                <div class="cell small-12 medium-4 bordered light shadowed">
                    <div
                        v-if="activeColour === false"
                        class="text-center">
                        <img
                            class="single-product-image"
                            v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=700`"
                            v-bind:alt="garment.img_alt_tag" />
                    </div>
                    <div
                        v-else
                        class="text-center"
                        >
                        <img
                            class="single-product-image pad"
                            v-bind:src="`https://runsmart-dropship.s3.eu-west-2.amazonaws.com/garments/pencarrie_images/${garment.product_code}+${activeColour.code}+FRONT.jpg`"
                            v-bind:alt="`${img_alt_tag} front`" /><br />
                        <img
                            class="single-product-image pad"
                            v-bind:src="`https://runsmart-dropship.s3.eu-west-2.amazonaws.com/garments/pencarrie_images/${garment.product_code}+${activeColour.code}+BACK.jpg`"
                            v-bind:alt="`${img_alt_tag} back`" /><br />
                        <img
                            class="single-product-image pad"
                            v-bind:src="`https://runsmart-dropship.s3.eu-west-2.amazonaws.com/garments/pencarrie_images/${garment.product_code}+${activeColour.code}+RIGHT.jpg`"
                            v-bind:alt="`${img_alt_tag} right`" />
                    </div>
                </div>
                <div class="cell small-12 medium-6 bordered light shadowed">
                    <div class="pad">
                        <h1 class="text-blue">{{ garment.h_one }}</h1>
                        <p class="lead text-right text-heavy">
                            From <span class="text-light-blue">&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</span><br />
                        </p>
                        <label
                            class="large-label text-blue border-under marg-top">
                            Colours
                        </label>
                        <ul class="colour-list large float-right">
                            <li
                                v-on:click="chooseColour(index)"
                                v-for="(colour, index) in garment.garment_colours"
                                v-bind:key="index"
                                v-bind:title="colour.name">
                                <span
                                    v-if="colour.hex_colour.length === 6"
                                    v-bind:class="{ active: ( colour.id === activeColour.id )}"
                                    v-bind:style="{ backgroundColor: '#' + colour.hex_colour }"
                                    class="colour-link">
                                    {{ colour.name }}
                                </span>
                                <div
                                    v-else
                                    v-bind:class="{ active: ( colour.id === activeColour.id )}"
                                    class="multi-colour-container">
                                    <i
                                        v-bind:style="{ backgroundColor: '#' + colour.hex_colour.substring(0, 6) }"
                                        class="left-half">
                                        {{ colour.name }}
                                    </i><i
                                        v-bind:style="{ backgroundColor: '#' + colour.hex_colour.substring(8) }"
                                        class="right-half">
                                        {{ colour.name }}
                                    </i>
                                </div>
                            </li>
                        </ul>
                        <p class="clear">&nbsp;</p>
                        <div v-if="activeColour !== false">
                            <p>Selected colour: {{ activeColour.name }}</p>
                            <div v-if="nextButtons === false">
                                <label class="large-label text-blue border-under">Sizes</label>
                                <form v-on:submit="addToBasket">
                                    <div class="grid-x grid-padding-x pad-top">
                                        <div
                                            class="cell small-12 medium-4"
                                            v-for="(size, index) in activeColour.garment_colour_sizes"
                                            v-bind:key="index">
                                            <label>{{ size.size }}</label>
                                            <input
                                                v-model="activeColour.garment_colour_sizes[index].number"
                                                type="number"
                                                min="0"
                                                step="1"
                                                placeholder="0">
                                        </div>
                                    </div>
                                    <div class="grid-x grid-padding-x pad-top">
                                        <div class="cell small-12">
                                            <button
                                                class="button light-blue text-white expanded">
                                                <i class="material-icons text-white shopping-cart-icon">shopping_cart</i>
                                                Add to Basket
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                             <div v-if="nextButtons === true" class="text-right">
                                <app-mini-basket></app-mini-basket>
                            </div>
                        </div>
                        <div
                            v-if="nextButtons === false"
                            class="pad-top"
                            v-html="garment.description">
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-x grid-margin-x marg-top--xl">
                <div class="cell small-12">
                    <ul class="tab-navigation">
                        <li v-on:click="activeTab = 1" v-bind:class="{ active : (activeTab === 1) }">
                            Product details
                        </li>
                        <li v-on:click="activeTab = 2" v-bind:class="{ active : (activeTab === 2) }">
                            Size guide
                        </li>
                        <li v-on:click="activeTab = 3" v-bind:class="{ active : (activeTab === 3) }">
                            Price guide
                        </li>
                    </ul>
                    <div
                        v-if="activeTab === 1"
                        class="tab-body">
                        <h4 class="text-blue text-heavy marg-bottom--none">Product details</h4>
                        <div v-html="garment.features"></div>
                    </div>
                    <div
                        v-if="activeTab === 2"
                        class="tab-body">
                        <h4 class="text-blue text-heavy marg-bottom--none">Size guide</h4>
                        <dl>
                            <dt v-if="garment.size_description_one">{{ garment.size_description_one }}</dt>
                            <dd  v-if="garment.size_description_one">{{ garment.size_list_one }}</dd>
                            <dt v-if="garment.size_description_two">{{ garment.size_description_two }}</dt>
                            <dd  v-if="garment.size_description_two">{{ garment.size_list_two }}</dd>
                            <dt v-if="garment.size_description_three">{{ garment.size_description_three }}</dt>
                            <dd  v-if="garment.size_description_three">{{ garment.size_list_three }}</dd>
                            <dt v-if="garment.size_description_four">{{ garment.size_description_four }}</dt>
                            <dd  v-if="garment.size_description_four">{{ garment.size_list_four }}</dd>
                            <dt v-if="garment.size_description_five">{{ garment.size_description_five }}</dt>
                            <dd  v-if="garment.size_description_five">{{ garment.size_list_five }}</dd>
                            <dt v-if="garment.size_description_six">{{ garment.size_description_six }}</dt>
                            <dd  v-if="garment.size_description_six">{{ garment.size_list_six }}</dd>
                        </dl>
                        <p class="lead">Please note all sizes are quoted with +/- 2cm tolerance</p>
                    </div>
                    <div
                        v-if="activeTab === 3"
                        class="tab-body">
                        <h4 class="text-blue text-heavy marg-bottom--none">Price guide</h4>
                        <table>
                            <tbody>
                                <tr>
                                    <th class="text-left">Quantity</th>
                                    <td>1</td>
                                    <td>10</td>
                                    <td>35</td>
                                    <td>100</td>
                                    <td>250</td>
                                    <td>500</td>
                                </tr>
                                <tr>
                                    <th class="text-left">Garment price</th>
                                    <td>&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*115)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</td>
                                    <td>&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*90)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</td>
                                    <td>&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*75)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</td>
                                    <td>&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*55)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</td>
                                    <td>&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*45)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</td>
                                    <td>&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</td>
                                </tr>
                                <tr>
                                    <th class="text-left">Print</th>
                                    <td>&pound;5.50</td>
                                    <td>&pound;4.50</td>
                                    <td>&pound;2.99</td>
                                    <td>&pound;1.99</td>
                                    <td>&pound;1.49</td>
                                    <td>&pound;0.99</td>
                                </tr>
                                <tr>
                                    <th class="text-left">Embroidery (Up to 10,000 stitches)</th>
                                    <td>&pound;5.50</td>
                                    <td>&pound;4.50</td>
                                    <td>&pound;3.50</td>
                                    <td>&pound;2.50</td>
                                    <td>&pound;1.99</td>
                                    <td>&pound;1.49</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="grid-x grid-margin-x marg-top pad-top--xl">
                <div class="cell small-12">
                    <h4 class="text-center text-light-grey">Similar Products</h4>
                </div>
            </div>
            <div class="grid-x grid-margin-x marg-top">
                <div
                    v-for="relatedGarment in garment.relatedGarments"
                    v-bind:key="relatedGarment.id"
                    class="cell small-6 medium-3 garment-card marg-bottom--small pad--xs relative">
                    <div>
                        <span
                            v-if="isAuthenticated === true"
                            v-on:click="addFavourite(relatedGarment.id)"
                            class="favourite">
                            <img src="../../../static/images/filter-garments/favourite.png" alt="" />
                        </span>
                        <div class="pad--large">
                            <img
                                v-bind:src="`https://our-catalogue.com/RUNS/images/${relatedGarment.product_code}.jpg?width=300`"
                                alt="" />
                        </div>
                        <p class="small text-heavy">
                            {{ relatedGarment.product_code }}<br />
                            {{ relatedGarment.name }}<br />
                            From:
                            <span class="text-light-blue">
                                £{{ (((relatedGarment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}
                            </span>
                        </p>
                        <router-link
                            class="add-to-basket"
                            v-bind:to="`/${relatedGarment.category}/${relatedGarment.product_code}/${relatedGarment.name}`">
                            <img
                                width="55"
                                src="../../../static/images/filter-garments/add-to-basket.png"
                                alt="" />
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import MiniBasket from '@/components/Header/MiniBasket';
import axios from '../../axios';

export default {
    name: 'SingleGarment',
    metaInfo() {
        return {
            title: this.pageTitle,
            titleTemplate: '%s for Sale Online | Customised Clothing',
            meta: [
                { description: this.garment.meta_description },
                { title: this.garment.meta_title },
            ],
            link: [
                { rel: 'canonical', href: `https://customisedclothing.com/${this.garment.category}/${this.garment.product_code}/${this.garment.name}` },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
        appMiniBasket: MiniBasket,
    },
    data() {
        return {
            garment: {
                product_code: '',
                brand: '',
            },
            activeColour: false,
            nextButtons: false,
            activeTab: 1,
        };
    },
    computed: {
        pageTitle() {
            const title = this.garment.name;
            return title;
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
    },
    methods: {
        garmentDetails() {
            const garmentId = this.$route.params.id;
            axios.get(`/Garments/fetchSingle/${garmentId}.json`)
                .then((response) => {
                    const name = this.$route.params.name;
                    if (name !== response.data.garment.slug) {
                        this.$router.push('/');
                    }
                    this.garment = response.data.garment;
                    this.activeColour = response.data.garment.garment_colours[0];
                    this.singleGarment = true;
                });
        },
        chooseColour(index) {
            if (this.nextButtons === true) this.nextButtons = false;
            this.activeColour = this.garment.garment_colours[index];
        },
        addToBasket(event) {
            event.preventDefault();
            this.$store.dispatch('addGarmentToBasket', this.activeColour.garment_colour_sizes);
            this.nextButtons = true;
        },
        addGarment() {
            this.activeColour = false;
            this.nextButtons = false;
        },
        addColour() {
            this.activeColour = false;
            this.nextButtons = false;
        },
        nextStep() {
            this.$router.push('/order/design');
        },
    },
    watch: {
        $route() {
            this.garmentDetails();
        },
    },
    mounted() {
        this.garmentDetails();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Garments/SingleGarment.vue